import axiosInstance from "../interceptor/interceptor";
import disbursementRequestDictionary from "../dictionary/disbursementRequestDictionary";

const disbursementRequestServices = {
  getDisbursementRequestDetails: (applicationId: string) =>
    axiosInstance.post(
      disbursementRequestDictionary.getDisbursementRequestDetails(),
      {
        applicationId,
      }
    ),
};

export default disbursementRequestServices;
